/* eslint-disable import/prefer-default-export */
import Client from 'Classes/Client';
import { getTimestampFromString } from 'Helpers/DateTime';
import moment from 'moment';

function convertResponse(response) {
  const client = new Client();
  // const { attributes } = response;
  client.id = response.id;
  const { attributes } = response;
  client.householdId = attributes.householdId;
  client.birthDate = getTimestampFromString(attributes.birthDate);
  client.firstName = attributes.firstName;
  client.lastName = attributes.lastName;
  client.pronunciation = attributes.pronunciation;
  client.paymentMethod = attributes.paymentMethod;
  client.paymentSchedule = attributes.paymentSchedule;
  client.emailAddresses = attributes.emailAddresses;
  client.primaryPhoneNumber = attributes.primaryPhoneNumber;
  client.isPrimary = attributes.isPrimary;
  return client;
}

function convertRequest(request) {
  return {
    id: request.id,
    type: 'client',
    attributes: {
      householdId: request.householdId.toString(),
      isPrimary: request.isPrimary.toString(),
      birthDate: request.birthDate,
      primaryPhoneNumber: request.primaryPhoneNumber,
      firstName: request.firstName,
      lastName: request.lastName,
      pronunciation: request.pronunciation,
    },
  };
}

function getClientBirthday(clients, isPrimary) {
  let birthdate = '';
  clients.forEach((client) => {
    if (client.isPrimary === isPrimary) {
      birthdate = client.birthDate;
    }
  });
  return birthdate;
}

const ageFromISOString = str => moment()
  .utc()
  .diff(moment.utc(str), 'years');

function getBirthdayAndAge(birthDate) {
  const birthDateMoment = moment.utc(birthDate);
  const age = moment.utc().diff(birthDateMoment, 'years', false);
  const birthDateContent = `${birthDateMoment.format(
    'M/DD/YYYY',
  )} - ${age} Years Old`;
  return birthDateContent;
}

// I'm making this a utility because I've had to do this multiple times.
// should display:
//     <primaryFirst> <primaryLast> if only one client
//     <primaryFirst> and <spouseFirst> <primaryLast> if has spouse and same last name
//     <primaryFirst> <primaryLast> and <spouseFirst> <spouseLast> if has spouse w/ different last name
export const combineNames = (primaryFirst, primaryLast, spouseFirst, spouseLast) => {
  let names;
  if (spouseFirst && spouseLast && spouseLast !== primaryLast) {
    names = `${primaryFirst} ${primaryLast} and ${spouseFirst} ${spouseLast}`;
  } else if (spouseFirst) {
    names = `${primaryFirst} and ${spouseFirst} ${primaryLast}`;
  } else {
    names = `${primaryFirst} ${primaryLast}`;
  }
  return names;
};

export {
  convertResponse,
  convertRequest,
  ageFromISOString,
  getClientBirthday,
  getBirthdayAndAge,
};
